import { render } from "./company_cases.html?vue&type=template&id=c5b7c2bc&external"
import script from "./company_cases.js?vue&type=script&lang=js&external"
export * from "./company_cases.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__